var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66944 1.75519C3.66944 2.71205 2.94087 3.48642 1.8015 3.48642C0.706533 3.48642 -0.0220387 2.71205 0.000508949 1.75519C-0.0220387 0.75182 0.706515 0 1.82333 0C2.94085 0 3.6476 0.75182 3.66944 1.75519ZM0.0921123 15.9996V4.85407H3.55599V15.9989H0.0921123V15.9996Z",
    fill: "#4776E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33233 8.40913C6.33233 7.01893 6.28652 5.83377 6.24072 4.85365H9.24942L9.40936 6.38055H9.47772C9.9336 5.67382 11.073 4.60352 12.9191 4.60352C15.1978 4.60352 16.9072 6.10786 16.9072 9.38854V15.9992H13.4433V9.82258C13.4433 8.38587 12.9423 7.40646 11.6888 7.40646C10.7312 7.40646 10.1619 8.06739 9.93432 8.70506C9.84272 8.93336 9.79762 9.25184 9.79762 9.57173V15.9992H6.33372V8.40913H6.33233Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8c1f46c089185b733298335c78116444.svg";
export { ForwardRef as ReactComponent };